import { render, staticRenderFns } from "./ThePage.vue?vue&type=template&id=448b48da&scoped=true"
import script from "./ThePage.vue?vue&type=script&lang=js"
export * from "./ThePage.vue?vue&type=script&lang=js"
import style0 from "./ThePage.vue?vue&type=style&index=0&id=448b48da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b48da",
  null
  
)

export default component.exports